import { v3WithImageBg } from '@consumer/logic/v3'

export function giftlyBackgroundUrl (designName: string) {
  if (designName !== v3WithImageBg) {
    return `https://assets2.giftly.com/giftly-assets/giftly-designs/backgrounds/${designName}.png`
  }
}

export function extractUrlPath (url: string) {
  const urlObj = new URL(url)
  return [urlObj.pathname, urlObj.search].filter(Boolean).join('')
}

// Builds a safe CSS `url('...')` token from an untrusted URL string.
// Escapes characters that would let the value break out of the url() token
// and inject other CSS declarations.
export function cssUrl (url: string | null | undefined): string | null {
  if (!url) return null
  const escaped = url.replace(/[\\'"()\s]/g, char => `\\${char}`)
  return `url('${escaped}')`
}
